


















import IPackageList from "@/Models/Work/IPackageList";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import SystemAppBar from "./components/System/SystemAppBar.vue";
@Component({
  components: {SystemAppBar},
})
export default class App extends Vue
{
	@Getter("IsItDark") private _getterIsDark!: boolean;
  @Action("InitializeApp") private _initApp!: any;
  @Getter("GetSplitPackages") private getSplitPackages!: IPackageList[];

  public async created()
  {
    await this._initApp();
  }
}
